<template>
  <div class="top">
    <div class="left">
      <div class="one">
        <p style="font-size: 50px" v-if="userInfo.lesseeInfoVo">
          {{ userInfo.lesseeInfoVo.lesseeName.charAt(0) }}
        </p>
        <p v-if="userInfo.lesseeInfoVo" class="num">{{ userInfo.lesseeInfoVo.lesseeCode }}</p>
      </div>
      <div class="two">
        <span class="name" v-if="userInfo.lesseeInfoVo">{{ userInfo.lesseeInfoVo.lesseeName }}</span>
        <span
          class="label"
          :class="{ 'label-active': userInfo.identityWill === 'Y' }"
          @click="setIntentionFn"
          v-if="userInfo.accendantId === uidObj.userId"
        >意向</span
        >
        <div style="margin-top: 10px">
          <a-tag color="pink" v-if="userInfo.identityFive === 'Y'"> 五 </a-tag>
          <a-tag color="green" v-if="userInfo.identityExcellent === 'Y'"> 优 </a-tag>
        </div>
      </div>
    </div>
    <div class="right"></div>
  </div>
</template>

<script>
export default {
    props: {
        userInfo: {
            type: Object,
            default: () => ({})
        },
        uidObj: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        userInfo: {
            handler () {},
            deep: true,
            immediate: true
        },
        uidObj: {
            handler () {},
            deep: true,
            immediate: true
        }
    },
    data () {
        return {

        }
    },
    methods: {
        // 点亮或者取消意向
        setIntentionFn () {
            this.$emit('setIntentionFn')
        }
    }
}
</script>

<style lang="less" scoped>
.top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    .left {
      width: 50%;
      display: flex;
      .one {
        position: relative;
        width: 160px;
        height: 160px;
        background-color: var(--ThemeColor);
        border-radius: 10px;
        color: white;
        font-size: 26px;
        text-align: center;
        line-height: 160px;
        .num {
          position: absolute;
          // left: 50%;
          // transform: translateX(-50%);
          bottom: -110px;
          font-size: 14px;
          color: #222;
        }
      }
      .two {
        margin-left: 20px;
        margin-top: 20px;
        .name {
          font-weight: 700;
          font-size: 20px;
          color: #000;
        }
        .label {
          display: inline-block;
          width: 50px;
          height: 30px;
          background-color: #999;
          color: white;
          text-align: center;
          line-height: 30px;
          border-radius: 4px;
          margin-left: 20px;
          cursor: pointer;
        }
        .label-active {
          background-color: var(--ThemeColor);
        }
      }
    }
    .right {
      width: 30%;
    }
  }
</style>
